<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto login-form">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <p class="text-header">Welcome back, log in to access your dashboard</p>
        <div class="options">
          <mat-radio-group class="radio-group">
            <div class="radio-option">
              <div class="radio-option-item">
                <mat-radio-button value="client" class="radio-button" [checked]="isClient" disableRipple
                  (change)="changeType($event)">Client</mat-radio-button>
              </div>
            </div>
            <div class="radio-option">
              <div class="radio-option-item" >
                <mat-radio-button value="partner" class="radio-button" [checked]="!isClient" disableRipple
                  (change)="changeType($event)">Partner</mat-radio-button>
              </div>
            </div>
          </mat-radio-group>
        </div>
        <div class="form-wrapper">
          <div class="error-message text-center" *ngIf="showError">
            {{ errorMessage }}
          </div>
          <div class="form-group">
            <input type="email" class="form-control content-input" formControlName="email" placeholder="Your Email"
              [ngClass]="{
                'is-valid': emailCtrl.valid && emailCtrl.touched,
                'is-invalid': !emailCtrl.valid && emailCtrl.touched
              }" [class.showError]="showError" />
          </div>
          <div class="form-group">
            <input type="password" class="form-control content-input" formControlName="password" autocomplete="off"
              placeholder="Password" [ngClass]="{
                'is-valid': passwordCtrl.valid && passwordCtrl.touched,
                'is-invalid': !passwordCtrl.valid && passwordCtrl.touched
              }" [class.showError]="showError" />
          </div>
          <div class="forgot-password">
            <a routerLink="/auth/login/reset-password" class="link text-link">Forgotten your password?</a>
          </div>
        </div>
        <div class="footer text-left p-3 security-advisory">
          <p class="text-center font-weight-bold">
            SECURITY NOTICE
          </p>
          <p>
            For your protection, please read and acknowledge the following notice:
          </p>
          <p class="font-weight-bold">
            Privalgo employees will never ask you for:
          </p>
          <ul class="pb-2">
            <li>Your passwords.</li>
            <li>Your memorable security number.</li>
            <li>Your full bank account details.</li>
            <li>Authy codes or any 2FA/MFA-related data (app tokens or SMS).</li>
            <li>Remote access to your computer or mobile device, other than Upscope (our screen share solution is only accessible via our secure client portals).</li>
            <li>Personal information via unofficial channels like WhatsApp: Any request for sensitive information will always be made through official Privalgo communication channels.</li>
            <li>Immediate action under threat or a sense of urgency: Genuine Privalgo requests will always allow you time to verify their authenticity.</li>
          </ul>
          <p>It’s important to only log in from a secure, trusted device. Be aware of phishing attempts and always verify communication from Privalgo through our official channels</p>
          <mat-checkbox 
              class="greengo break-line"
              [ngClass]="{
                'is-valid': agreeSecurityAdvisoryCtrl.value && agreeSecurityAdvisoryCtrl.touched,
                'is-invalid': !agreeSecurityAdvisoryCtrl.value
              }"
              formControlName="agreeSecurityAdvisory" 
              disableRipple 
              >
                I have read and understood this security notice.
            </mat-checkbox>
            <div *ngIf="!agreeSecurityAdvisoryCtrl.value && loginForm.get('agreeSecurityAdvisory').touched">
              <p class="text-danger">Please acknowledge our security notice before proceeding</p>
            </div>
            <p class="pt-2">By ticking this box, you confirm your understanding of our security practices and agree to proceed with logging in.</p>
        </div>
        <div class="form-group">
          <button class="btn btn-block" type="submit" [ngClass]="{
            'btn-greengo': loginForm.valid && agreeSecurityAdvisoryCtrl.value,
            'btn-inactive': !loginForm.valid || !agreeSecurityAdvisoryCtrl.value
          }" npFocusOutClicked>Login</button>
        </div>
        <p class="privacy-policy">  
          By logging in, you agree to {{brandName}} Limited's 
          <a target="_blank" rel="noopener noreferrer" href="https://www.{{domain}}/privacy-policy"
            class="link">Privacy Policy</a>
          and
          <a target="_blank" rel="noopener noreferrer" href="https://www.{{domain}}/terms-of-use-website/"
            class="link">Terms of Use</a>
        </p>
        <div class="footer">
          <p class="p-footer">
            Don’t have an account?
            <a routerLink="/auth/register/" class="link sign-up">Sign up</a>
          </p>
        </div>
      </form>
      <ng-container *ngIf="showAlertChrome">
        <div class="d-flex">
          <img src="/assets/images/icon/Google_Chrome_icon.svg" height="33px" width="33px" /> &nbsp;&nbsp;
          <span class="alert-text">For the best experience, please use Google Chrome to access this portal
            <br class="d-md-block d-none">
            <a class="link" href="https://www.google.com/chrome/" target="_blank">Download Chrome</a>
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
